import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceInfo } from '../classes';
import {SettingsmanagerService} from './settingsmanager.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

  private _url: string;

  constructor(
    private _http: HttpClient,
    private settingsManager: SettingsmanagerService
  ) {
    this._url =  this.settingsManager.getBaseWsUrl();
  }

  getDeviceInfoDetail(id: number): Observable<DeviceInfo> {
    return this._http.get<DeviceInfo>(`${this._url}/deviceInfo/${id}`).pipe(
        map(obj => new DeviceInfo(obj))
    );
  }

  editInfo(id: number, objDeviceInfo: DeviceInfo, file?: File): Observable<any> {
    const formData = new FormData();
    
    Object.keys(objDeviceInfo).forEach(key => {
      formData.append(key, (objDeviceInfo as any)[key]);
    });
  
    if (file) {
      formData.append('file', file, file.name);
    }
  
    return this._http.patch<any>(`${this._url}/deviceInfo/${id}`, formData);
  }
  
  getRegistrationCertificateFile(id: number): Observable<Blob> {
    return this._http.get(`${this._url}/deviceInfo/${id}/download`, { responseType: 'blob' });
  }
}
